import { ReactNode, useEffect, useState } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingConcierge } from "@/components/concierge/FloatingConcierge";
import { supabase } from "@/integrations/supabase/client";

interface LayoutProps {
  children: ReactNode;
  user?: { email: string; name?: string } | null;
  onSignOut?: () => void;
  hideFooter?: boolean;
  transparentHeader?: boolean;
}

export function Layout({ children, user: userProp, onSignOut: onSignOutProp, hideFooter, transparentHeader }: LayoutProps) {
  const [authUser, setAuthUser] = useState<{ email: string; name?: string } | null>(null);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setAuthUser({
          email: session.user.email || "",
          name: session.user.user_metadata?.name,
        });
      } else {
        setAuthUser(null);
      }
    });

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setAuthUser({
          email: session.user.email || "",
          name: session.user.user_metadata?.name,
        });
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const user = userProp !== undefined ? userProp : authUser;
  const handleSignOut = onSignOutProp || (async () => {
    await supabase.auth.signOut();
    setAuthUser(null);
  });

  return (
    <div className="flex min-h-screen flex-col">
      <Header user={user} onSignOut={handleSignOut} transparent={transparentHeader} />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
      <FloatingConcierge />
    </div>
  );
}
